import styles from './StepperSkeleton.module.css';

export const StepperSkeleton = () => {
  return <div className={styles.card} />;
};
